import { Component } from '@angular/core';
import { environment } from '../../../Environment/environment';

@Component({
  selector: 'app-footer-spinea',
  templateUrl: './footer-spinea.component.html',
  styleUrl: './footer-spinea.component.css'
})
export class FooterSpineaComponent {
currentYear: Date = new Date();
  AssetbasePath = environment.assetsPath;
}
